import * as React from 'react';

import { useTranslation } from 'react-i18next';

import bannerImg from '@assets/images/nomad/bonus_banner.webp';

import { Button } from '@components/button';

import * as Styled from './bonuses.styled.ts';

const Bonuses = () => {
	const { t } = useTranslation('nomad');

	return (
		<Styled.Wrapper>
			<Styled.Content>
				<Styled.Title>{t('home_title_1')}</Styled.Title>
				<Styled.Description>{t('home_desc_1')}</Styled.Description>
				<Styled.ActionStyled>
					<Button color='primary'>{t('home_btn_1')}</Button>
				</Styled.ActionStyled>
			</Styled.Content>
			<Styled.ImageWrapper>
				<img src={bannerImg} alt='bonuses wheel banner' />
			</Styled.ImageWrapper>
		</Styled.Wrapper>
	);
};

export default Bonuses;
